import { render, staticRenderFns } from "./BidCreate.vue?vue&type=template&id=bdaba0f4"
import script from "./BidCreate.vue?vue&type=script&lang=js"
export * from "./BidCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports